module.exports = __webpack_public_path__ + "img/manual-icon.01d9309.svg";